import OwnerModel from './OwnerModel'
import Instance from '@/models/Instance'

export default class Storage extends OwnerModel {
  static entity = 'externalStorage'

  static primaryKey = ['instance_id', 'external_storage_id']

  static fields () {
    return {
      ...super.fields(),
      external_storage_id: this.number(null).nullable(),
      __type: this.attr('external_storage'),
      type: this.string(null).nullable(),
      endpoint: this.string(null).nullable(),
      region: this.string(null).nullable(),
      identity: this.string(null).nullable(),
      credential: this.string(null).nullable(),
      creation_time: this.string(null).nullable(),
      modify_time: this.string(null).nullable(),
      can_alter: this.boolean(false).nullable(),
      can_drop: this.boolean(false).nullable(),
      can_usage: this.boolean(false).nullable()
    }
  }

  get id() {
    return this.external_storage_id
  }
}
